module.exports = __webpack_public_path__ + "img/result_5.7cc01922.png";